import * as Yup from 'yup';
import i18n from 'i18n';
import { ISignUpDto, ISignInDto } from 'interfaces/auth.interface';

export const SIGN_UP_VALIDATION_SCHEMA = (): Yup.ObjectSchema<ISignUpDto> => {
  return Yup.object().shape({
    username: Yup.string()
      .required(i18n.t('validation.required') as string)
      .min(12, i18n.t('validation.minLength', { value: 12 }) as string),
    password: Yup.string()
      .required(i18n.t('validation.required') as string)
      .min(8, i18n.t('validation.minLength', { value: 8 }) as string),
    qoldauToken: Yup.string().required(i18n.t('validation.required') as string),
  });
};

export const SIGN_IN_VALIDATION_SCHEMA = (): Yup.ObjectSchema<ISignInDto> => {
  return Yup.object().shape({
    username: Yup.string().required(i18n.t('validation.required') as string),
    password: Yup.string().required(i18n.t('validation.required') as string),
  });
};
